import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { inject } from 'mobx-react';
import { EGDSTertiaryButton } from '@egds/react-core/button';
import { EGDSEmptyState, EGDSEmptyStateActionArea } from '@egds/react-core/empty-state';
import { EGDSIcon } from '@egds/react-core/icons';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSHeading, EGDSText } from '@egds/react-core/text';
import { useLocalization } from '@shared-ui/localization-context';
import { handleRetry } from 'utils/error-handling-utils';
import { PackageError } from '../multi-item/package-error';
export const SearchErrorMessageWrapper = inject('searchResults', 'analytics')(({
  searchResults,
  analytics
}) => {
  const {
    formatText
  } = useLocalization();
  const history = useHistory();
  const location = useLocation();
  const isError = searchResults === null || searchResults === void 0 ? void 0 : searchResults.isError;
  const searchCriteria = searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchCriteria;
  const {
    misId
  } = searchCriteria || {};
  if (!isError) {
    return null;
  }
  if (misId) {
    return React.createElement(EGDSSpacing, {
      padding: {
        blockstart: 'six',
        blockend: 'twelve'
      }
    }, React.createElement("div", null, React.createElement(EGDSText, {
      align: "center"
    }, React.createElement(PackageError, {
      searchResults: searchResults,
      analytics: analytics
    }))));
  }
  const errorMessage = formatText('hotels.searchResults.error.text');
  const errorCta = isError ? formatText('hotels.searchResults.error.cta') : '';
  return React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'twelve'
    }
  }, React.createElement("div", {
    "data-stid": "empty-state-error"
  }, React.createElement(EGDSText, {
    align: "center"
  }, React.createElement(EGDSSpacing, {
    padding: {
      blockstart: 'three'
    }
  }, React.createElement(EGDSEmptyState, {
    "data-stid": 'retry-search'
  }, React.createElement(EGDSIcon, {
    name: 'error'
  }), React.createElement(EGDSHeading, {
    tag: "h2"
  }, errorMessage), React.createElement(EGDSEmptyStateActionArea, null, React.createElement(EGDSTertiaryButton, {
    name: "textonly",
    onClick: () => handleRetry(':errorOnSearch', 'Try Again on error', analytics, searchResults, history, location),
    type: "button"
  }, errorCta)))))));
});